import decode from 'jwt-decode'
import axios from 'axios'
import auth0 from 'auth0-js'
import Router from 'vue-router'
import Auth0Lock from 'auth0-lock'
const ID_TOKEN_KEY = 'id_token'
const ACCESS_TOKEN_KEY = 'access_token'

const AUTH0_CLIENT_ID = process.env.AUTH0_CLIENT_ID // 'VvCLGC2P0K9n0JLQlhpozVPwfJxCy34l'
const AUTH0_CLIENT_DOMAIN = process.env.AUTH0_CLIENT_DOMAIN // 'trailtones.auth0.com'

// Hack to static callbck file
// Hash in URL messes things up
// this file redirect back to the callback accepting route /callback
// which will write the access token to local storage
const REDIRECT = process.env.AUTH0_CALLBACK_URL // 'http://localhost:8080/auth-callback.html'

const SCOPE = 'full_access'
const AUDIENCE = 'https://www.trailtones.com'

var auth = new auth0.WebAuth({
  clientID: AUTH0_CLIENT_ID,
  domain: AUTH0_CLIENT_DOMAIN
})

export function login() {

  auth.authorize({
    responseType: 'token id_token',
    scope: 'openid email profile',
    redirectUri: REDIRECT,
    audience: AUDIENCE,
    prompt: 'login'
  })

}

var router = new Router({
  mode: 'history'
})

export function clearTokens() {
  clearIdToken()
  clearAccessToken()
}


export function logout() {
  clearIdToken()
  clearAccessToken()
  router.go('/')
}

export function requireAuth(to, from, next) {
  if (!isLoggedIn()) {
    next({
      path: '/',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

export function getIdToken() {
  console.log(window.location.hash)
  return localStorage.getItem(ID_TOKEN_KEY)

}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY)
}

function clearIdToken() {
  localStorage.removeItem(ID_TOKEN_KEY)
}

function clearAccessToken() {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
}

// Helper function that will allow us to extract the access_token and id_token
function getParameterByName(name) {
  //debugger
  let match = RegExp('[#&]' + name + '=([^&]*)').exec(window.location.hash)
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '))
}

// Get and store access_token in local storage
export function setAccessToken() {
  let accessToken = getParameterByName('access_token')
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken)
}

// Get and store id_token in local storage
export function setIdToken() {
  let idToken = getParameterByName('id_token')
  localStorage.setItem(ID_TOKEN_KEY, idToken)
}

export function isLoggedIn() {
  const idToken = getIdToken()
  return !!idToken && !isTokenExpired(idToken)
}

function getTokenExpirationDate(encodedToken) {
  const token = decode(encodedToken)
  if (!token.exp) { return null }

  const date = new Date(0)
  date.setUTCSeconds(token.exp)

  return date
}

function isTokenExpired(token) {
  const expirationDate = getTokenExpirationDate(token)
  return expirationDate < new Date()
}



// WEBPACK FOOTER //
// ./src/utils/auth.js